module.exports = __webpack_public_path__ + "static/media/web-development.55e72a93.svg";